<!--
only used in Vue3
Vue2File: Velocity.PrimaryOffersites.Web\wwwroot\js\components\FooterPopups\additionaldisclosure.vue
-->
<template>
  <div>
    <Modal
      class="additionaldisclosure"
      title="Additional Disclosures"
      ref="additionalRef"
      @hideModal="closeModal()"
    >
      <div class="additional-body px-2 py-2 text-left">
        <div>
          <div>
            <strong>[1] Inventory Disclosure</strong>
          </div>
          <div>
            {{ disclaimerdata.disclaimerDto.mpgInventoryDisclaimerText }}
          </div>
        </div>
        <div class="pt-2">
          <div>
            <strong>
              [2]
              {{ isToyota ? "TSRP" : "MSRP" }}
            </strong>
          </div>
          <div>
            {{ disclaimerdata.disclaimerDto.msrpDisclaimerText }}
          </div>
        </div>
        <div class="pt-2">
          <div>
            <strong>[3] MPG Ratings</strong>
          </div>
          <div>
            {{ disclaimerdata.disclaimerDto.mpgDisclaimerText }}
          </div>
        </div>
        <div class="pt-2">
          <div>
            <strong>[4] Info</strong>
          </div>
          <div>
            {{ disclaimerdata.disclaimerDto.info }}
          </div>
        </div>
        <div class="pt-2" v-if="isAdditionalDisclosuresFD">
          <div><strong>Definitions and Disclosures</strong><br /><br /></div>
          <div>
            <template v-for="item in fordDirectDisclimer.Header">
              <div class="mt-2">{{ item.text }}</div>
            </template>
            <template v-for="(item, index) in fordDirectDisclimer.Body">
              <div class="mt-2">{{ index + 1 }}. {{ item.point }}</div>
            </template>
            <template v-for="item in fordDirectDisclimer.Footer">
              <div class="mt-2">{{ item.text }}</div>
            </template>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from "../../Shared/Modal/Modal.vue";
import axios from "axios";
import { Events } from "../../../Events/ConsumerEvents/Events";
import { FORD_DISCLOSURE } from "@/js/constants/fordDirectConstants";
import { LINCOLN_DISCLOSURE } from "@/js/constants/lincolnDisclosureConstants";
import { isFordDealer, isLincolnDealer } from "../../../Events/FordDirect/FordCookieService";
import { mapWritableState } from "pinia";
import { useFooterStore } from "../../../store/Shared/FooterStore/footerStore";
export default {
  data() {
    return {
      isToyota: window.themeName.toLowerCase() === "toyota" || false,
      disclaimerdata: {
        disclaimerDto: {
          mpgInventoryDisclaimerText: "loading...",
          mpgDisclaimerText: "loading...",
          msrpDisclaimerText: "loading...",
          info: "loading...",
        },
      },
      isAdditionalDisclosuresFD: window.isFdDealer,
      fordDirectDisclimer: {},
    };
  },
  props: {
    openadditionaldisclosure: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    Modal,
  },
  computed: {
    ...mapWritableState(useFooterStore, ["showAdditionalDisclosureModal"]),
  },

  mounted() {
    let eventmodel = {
      ...Events.consumerEventModel,
      consumerEventId: Events.eventsConstants.AdditionalDisclosure,
    };
    Events.logConsumerEvent(eventmodel);

    let disclosure = {};
    if (window.isFdDealer && isFordDealer(window.themeName)) {
      disclosure = FORD_DISCLOSURE;
    } else if (isLincolnDealer(window.themeName)) {
      disclosure = LINCOLN_DISCLOSURE;
    } else {
      // No action needed for other cases.
    }
    this.fordDirectDisclimer = this.getFordDirectDisclaimer(disclosure);
    this.$refs.additionalRef.show();
    axios
      .get(
        `${window.ApiBaseUrl}/DisclaimersService/AdditionalDisclaimer?make=${window.make}&accountId=${window.accountId}`
      )
      .then((response) => {
        this.disclaimerdata = response.data;
      });
  },
  methods: {
    closeModal() {
      this.showAdditionalDisclosureModal = false;
      this.$emit("hideModal");
    },
    getFordDirectDisclaimer(disclosure) {
      switch (window.state) {
        case "UT":
          return disclosure.utahDefinitionsDisclosure;
        case "TX":
          return disclosure.texasDefinitionsDisclosure;
        default:
          return disclosure.allDefinitionsDisclosure;
      }
    },
  },
};
</script>
<style>
.additional-body {
  color: #555;
  font-size: 14px;
}
@media (max-width: 800px) {
  .additionaldisclosure .modal-lg {
    width: 100%;
    max-width: 90%;
  }
}
</style>
